(ns manage.product-selector-page.widgets
  (:require ["@mui/material/Paper$default" :as Paper]
            ["@mui/material/Stack$default" :as Stack]
            ["@mui/material/SvgIcon$default" :as SvgIcon]
            ["@mui/material/Tooltip$default" :as Tooltip]
            ["@mui/material/Typography$default" :as Typography]
            ["src/svg/inform/info-circle.svg$default" :as InfoIcon]
            [uix.core :as uix :refer [$ defui]]))

(defui empty-section-message [{:keys [step-label]}]
  ($ Typography
     {:sx #js {:fontStyle "italic"
               :textTransform "lowercase"
               "&:first-letter" #js {:textTransform "uppercase"}}}
     "No " step-label " configured"))

(defui section-card [{:keys [title tooltip children]}]
  ($ Paper
     {:component Stack
      :gap 2
      :sx #js {:padding 3}}
     ($ Stack
        {:direction "row"
         :justifyContent "space-between"}
        ($ Typography {:variant "h3"} title)
        (when tooltip
          ($ Tooltip
             {:placement "right"
              :title tooltip}
             ($ SvgIcon {:sx #js {:color "grey.40"}}
                ($ InfoIcon)))))
     children))
